import { render, staticRenderFns } from "./SyncAccountsTab.vue?vue&type=template&id=c20279be&scoped=true";
import script from "./SyncAccountsTab.vue?vue&type=script&lang=jsx";
export * from "./SyncAccountsTab.vue?vue&type=script&lang=jsx";
import style0 from "./SyncAccountsTab.vue?vue&type=style&index=0&id=c20279be&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "c20279be", null);
export default component.exports;